import { useQuery } from 'react-query'
import { timeService } from '../services/time'
import { Time, TimeFilters, TimeFormData } from '../tipos/time'
import { useMutationWithToast } from '../../../hooks/useMutationWithToast'
import { useToast } from '../../../contexts/NotificationContext'

export function useTimesConfiguracao() {
  const toast = useToast()
  return useQuery('times-configuracao', () => timeService.listarTimesConfiguracao(), {
    onError: (error: any) => {
      toast.error(error?.message || 'Erro ao carregar configuração de times')
    },
  })
}

export function useTimes(filters?: TimeFilters) {
  const toast = useToast()
  return useQuery(['times', filters], () => timeService.listarTimes(filters), {
    keepPreviousData: true,
    onError: (error: any) => {
      toast.error(error?.message || 'Erro ao carregar times')
    },
  })
}

export function useTime(id?: number) {
  const toast = useToast()
  return useQuery(['time', id], () => timeService.getTimeById(id!), {
    enabled: !!id,
    onError: (error: any) => {
      toast.error(error?.message || 'Erro ao carregar time')
    },
  })
}

export function useCreateTime() {
  return useMutationWithToast<Time, TimeFormData>({
    mutationFn: timeService.criarTime,
    successMessage: 'Time criado com sucesso!',
    errorMessage: 'Erro ao criar time',
    invalidateQueries: 'times',
  })
}

export function useUpdateTime() {
  return useMutationWithToast<TimeFormData, { id: number; data: TimeFormData }>({
    mutationFn: ({ id, data }) => timeService.atualizarTime(id, data),
    successMessage: 'Time atualizado com sucesso!',
    errorMessage: 'Erro ao atualizar time',
    invalidateQueries: ['times', 'time'],
  })
}

export function useDeleteTime() {
  return useMutationWithToast<void, number>({
    mutationFn: timeService.excluirTime,
    successMessage: 'Time excluído com sucesso!',
    errorMessage: 'Erro ao excluir time',
    invalidateQueries: 'times',
  })
}
